module.exports = __webpack_public_path__ + "img/Flag_of_Barbados.f8439090.svg";